import { useMutation } from '@tanstack/react-query';

import { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

type UploadImageOptions = {
  mutationConfig?: MutationConfig<typeof uploadImage>;
};

type UploadDocumentType = {
  image: File | Blob;
};

export const uploadImage = ({ image }: UploadDocumentType) => {
  return extractData(api['image_files'].post({ image }));
};

export const useUploadImage = ({ mutationConfig }: UploadImageOptions = {}) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: uploadImage,
  });
};
